/**
 * Search-index logo fields are container-relative paths; absolute URLs pass through
 * untouched (same convention as useInstitutionProfile).
 */
export const resolveSearchLogoUrl = (
  appAssetsUrl: (path: string) => string,
  logoUrl: string | null | undefined,
): string | undefined => {
  if (!logoUrl) {
    return undefined;
  }
  return logoUrl.startsWith('http') ? logoUrl : appAssetsUrl(`/${logoUrl.replace(/^\//, '')}`);
};
